import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRConfirmSubmitModalViewModel from './OCRConfirmSubmitModalViewModel'
import JobCreationBilling from '../../../../../creation/views/JobCreationDialog/JobCreationBilling'
import CouponModal from '../../../../../creation/views/JobCreation/Submission/CouponModal'
import ModalSpinner from '../ModalSpinner'

/**
 * Confirm Submit Modal
 */
export default observer(function OCRConfirmSubmitModal({
  vm,
}: {
  vm: OCRConfirmSubmitModalViewModel
}) {
  const editor = vm.ocrScopingJobMainPanelViewModel.editor
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_invite-people.svg')}
          />
          <ModalSheetContentTitle>
            You are about to submit an OCR job scope
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you submit you will no longer
            be able to make any more changes.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        {vm.isBillingRelevant && (
          <ModalSheetContentBlock>
            <JobCreationBilling vm={editor} />
            <CouponModal vm={editor.submission.billing.couponSelection} />
          </ModalSheetContentBlock>
        )}
        {vm.ocrScopingJobMainPanelViewModel.submit.pending && (
          <ModalSheetContentBlock>
            <ModalSpinner />
          </ModalSheetContentBlock>
        )}
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button
            type="primary"
            disabled={vm.ocrScopingJobMainPanelViewModel.isPending}
            onClick={vm.confirm}
          >
            Submit
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
